<template>
  <!--意见反馈-->
  <div aria-labelledby="myModalLabel" class="modal fade" id="feedback" role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="iconfont icon-close"></i>
          </button>
          <h4 class="modal-title" id="myModalLabel">意见反馈</h4>
        </div>
        <div class="modal-body">
          <p class="alert alert-success" style="margin-bottom: 20px;">
            <i class="fa fa-exclamation-circle"></i> 感谢使用睿客网，如果您在使用过程中有任何改进建议，欢迎给我们留言反馈，或发送邮件到 rec@ustc.edu.cn
          </p>
          <div class="form-group has-feedback">
            <input
              type="text"
              class="form-control"
              placeholder="姓名"
              name="name"
              v-model.trim="form.name"
              data-vv-as="姓名 "
              v-validate="{ max: 64}"
            />
            <span
              id="helpBlock1"
              class="help-block"
              v-show="errors.has('name')"
            >{{ errors.first('name') }}</span>
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              placeholder="电子邮件"
              name="email"
              v-model.trim="form.email"
              data-vv-as="电子邮件 "
              v-validate="{ required: true, email: true }"
            />
            <span
              id="helpBlock2"
              class="help-block"
              v-show="errors.has('email')"
            >{{ errors.first('email') }}</span>
          </div>
          <div class="form-group">
            <textarea
              name="message"
              class="form-control"
              placeholder="留言"
              rows="5"
              style="resize: vertical;"
              autofocus
              v-model.trim="form.message"
              data-vv-as="留言 "
              v-validate="{ required: true, max: 500 }"
            ></textarea>
            <span
              id="helpBlock3"
              class="help-block"
              v-show="errors.has('message')"
            >{{ errors.first('message') }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" type="button">关闭</button>
          <button class="btn btn-primary" type="button" @click="feedback">提交</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { feedback } from "@/api/common/index";
export default {
  name: "Feedback",
  data() {
    return {
      form: {
        name: null,
        email: null,
        message: null
      }
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  methods: {
    feedback() {
      this.$validator.validate().then(valid => {
        if (valid) {
          feedback(this.form)
            .then(res => {
              if (res.status_code === 200) {
                $("#feedback").modal("hide");
                this.$message({
                  type: "success",
                  message: res.message
                });
                this.form = {
                  name: null,
                  email: null,
                  message: null
                };
                this.$nextTick(() => {
                  this.$validator.reset();
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message
                });
              }
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err
              });
            });
        }
      });
    }
  },
  mounted() {
    $("#feedback").on("shown.bs.modal", () => {
      this.form.name = this.userInfo.name;
      this.form.email = this.userInfo.email;
    });
  }
};
</script>

<style scoped>
</style>